// @ts-check
import { getCards } from '@/api/subscription'
import { service } from '@/core/constants'
import { setPaymentCardAdded } from '@/helpers/marketing'

const initSubscriptionState = () => ({
  card: null,
  invoices: []
})

const subscriptionMutations = {
  setCard: (state, card) => {
    state.card = card
    setPaymentCardAdded(card)
  }
}

const subscriptionGetters = {
  hasPaymentMethod: (state) => {
    if (state.card === null) {
      return false
    }

    return state.card.card_number !== null && state.card.card_number !== ''
  },
  requiresPaymentCardPrompt: (state, getters, rootState) => {
    // Payment card not required in TLP or OY services
    if (
      process.env.VUE_APP_SERVICE === service.TLP ||
      process.env.VUE_APP_SERVICE === service.OY
    ) {
      return false
    }

    return (
      rootState.companyData.company &&
      !!rootState.companyData.company.wizard_completed &&
      state.card !== null &&
      getters.hasPaymentMethod === false
    )
  },
  // After pricing update on 1.1.2026, payment card will be required in TLP.
  // Will be removed after extended trial is over.
  showPaymentCardPrompt: (state) => state.card?.show_card_prompt ?? false
}

const subscriptionActions = {
  async getCard({ commit }) {
    const { data } = await getCards()
    commit('setCard', data)
    return data
  }
}

export const subscriptionModule = {
  namespaced: true,
  state: initSubscriptionState,
  actions: subscriptionActions,
  mutations: subscriptionMutations,
  getters: subscriptionGetters
}

export default subscriptionModule
